import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { getPlans, getStripeProducts, createCheckout } from '../../services/api';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

const SubscriptionSelection = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setupProducts();
  }, []);

  const setupProducts = async () => {
    try {
      setLoading(true);
      const productsResult = await getStripeProducts();
      console.log(productsResult);
      setProducts(productsResult);
    } catch (ex) {
      console.log(ex);
    } finally {
      setLoading(false);
    }
  };

  const subscribe = async () => {
      const result = await createCheckout();
      console.log(result);
      window.location.href = result.checkoutUrl;
  };

  var productsJsx = products.map(p => {
    console.log('Product Selection', p)
    return (
      <div key={p.stripeId} className={`card card-subscription card-spaced`}>
        <div className='card-info'>
          <h4>{p?.name}</h4>
          <div className="subscripton-details">
            <div>${p?.price.toFixed(2)}</div>
          </div>
          <div className="pt-2">
            <button type="button" className="btn btn-primary" onClick={subscribe}>Subscribe</button>
          </div>
        </div>
      </div>
    );
  })

  return loading ? <div className="spinner"></div> : (
    <div className='plans-selection'>
      {productsJsx}
    </div>
  );
};

export default SubscriptionSelection;